// src/components/PrivateRoute.js
import React from "react";
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from "../AuthContext";
import Preloader from "./Preloader";

const PrivateRoute = () => {
  const { user, loading } = useAuth();

  // Attendre la vérification de session (GET /api/users/me) avant de trancher
  if (loading) return <Preloader show={true} />;

  const isSuperAdmin = user && user.role === "superAdmin";

  return isSuperAdmin ? <Outlet /> : <Navigate to="/" replace />;
};

export default PrivateRoute;
